import { create } from 'zustand'

interface State {
  isCartOpen: boolean
  isFavoritesOpen: boolean

  openFavorites: () => void
  closeFavorites: () => void

  openCart: () => void
  closeCart: () => void
}

export const useUIStore = create<State>()((set) => ({
  isCartOpen: false,
  isFavoritesOpen: false,

  //Open to slide the cart
  closeCart: () =>
    set((state) => (state.isCartOpen ? { isCartOpen: false } : state)),
  openCart: () =>
    set((state) => (!state.isCartOpen ? { isCartOpen: true } : state)),

  //Open to slide the favorites
  openFavorites: () => set({ isFavoritesOpen: true }),
  closeFavorites: () => set({ isFavoritesOpen: false })
}))
